export default "__VITE_ASSET__BET0ip88__"